import { StyleSheet, View } from 'react-native';

import { IconChevronRight, Pressable, Text, XStack, YStack, tokens } from '@fhs/ui';

import { ActionTileProps } from './types';

export function ActionTileDesktop(props: ActionTileProps) {
  return (
    <Pressable style={styles.container} onPress={props.onPress}>
      <XStack style={styles.content}>
        <View style={[styles.iconCircle, props.iconCircleStyle]}>{props.Icon}</View>
        <YStack style={styles.textWrapper}>
          <Text weight="semibold" style={props.isLoading ? styles.titleSkeleton : styles.title}>
            {props.title}
          </Text>
          <Text style={styles.subtitle}>{props.subtitle}</Text>
        </YStack>
      </XStack>
      <XStack style={styles.ctaWrapper}>
        {props.indicatorText && (
          <Text weight="semibold" style={styles.indicatorText}>
            {props.indicatorText}
          </Text>
        )}
        <IconChevronRight size={24} color={tokens.colors.$houseDark} />
      </XStack>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 24,
    gap: 12,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: tokens.colors.$blackOpacity10,
  },
  iconCircle: {
    height: 52,
    width: 52,
    borderRadius: 52,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: tokens.colors.$houseRedOpacity04,
  },
  content: {
    alignItems: 'center',
  },
  textWrapper: {
    marginLeft: 12,
    gap: 8,
  },
  title: {
    fontSize: 14,
  },
  titleSkeleton: {
    maxWidth: 60,
    height: 18,
    borderRadius: 3,
    backgroundColor: tokens.colors.$blackOpacity10,
  },
  subtitle: {
    fontSize: 12,
    lineHeight: 16.8,
  },
  ctaWrapper: {
    alignItems: 'center',
    gap: 10,
  },
  indicatorText: {
    fontSize: 12,
  },
});
